export const yandexMetrikaId = '88656916';
